import { Contact } from "./contacts";

export class ResourceLink {
	category?: string;
	carrier?: string;
	linkText: string;
	fileName: string;
	fileType: string;
	linkUrl: string;
	windowHeight?: number;
	windowWidth?: number;
	shouldOpenDialog?: boolean;

	constructor() {
		this.category = '';
		this.carrier = '';
		this.linkText = '';
		this.fileName = '';
		this.fileType = '';
		this.linkUrl = '';
		this.windowHeight = 0;
		this.windowWidth = 0;
		this.shouldOpenDialog = false;
	}
}

export class BenefitResourceLinks {
	benefitDocuments: ResourceLink[];
}

export class ResourceDocuments {
	documents: ResourceLink[];
}

export class CompanyResources {
	companyID: number;
	companyName: string;
	benefit: ResourceLink[];
	company: ResourceLink[];
	compliance: ResourceLink[];
	contacts: Contact[];
}